export const ESTADO_ACTIVO = {
  PENDIENTE: 1,
  ACTIVO: 2,
  VENDIDO: 3,
  AMORTIZADO: 4,
  DADO_DE_BAJA: 5,
} as const

export type EstadoActivoType =
  (typeof ESTADO_ACTIVO)[keyof typeof ESTADO_ACTIVO]
